import { ScrollReveal } from '@/components/ui/scroll-reveal'
import { CheckCircle2 } from 'lucide-react'

export const SolutionSection = () => {
  return (
    <section id="solution" className="py-24 bg-white">
      <div className="container px-4 md:px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <ScrollReveal>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 leading-tight mb-6">
              Software inteligente, <br className="hidden md:block" />
              <span className="text-primary">adaptado à tua operação.</span>
            </h2>
          </ScrollReveal>

          <ScrollReveal delay={200}>
            <div className="space-y-6 text-lg text-slate-600">
              <p>
                Na Núcleo Digital analisamos a forma como o teu negócio funciona
                e transformamos processos manuais em aplicações simples,
                funcionais e adaptadas à tua equipa.
              </p>
              <p>
                Integramos automação e inteligência artificial para executar
                tarefas, validar dados, gerar alertas, apoiar decisões e reduzir
                trabalho operacional.
              </p>
              <ul className="space-y-3 pt-4">
                {[
                  'Automação de tarefas repetitivas',
                  'Validação automática de dados',
                  'Alertas inteligentes',
                  'Apoio à decisão em tempo real',
                ].map((item) => (
                  <li key={item} className="flex items-center gap-3">
                    <CheckCircle2 className="text-primary h-5 w-5 flex-shrink-0" />
                    <span className="text-base font-medium text-slate-700">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  )
}
